import React from "react";

const DefaultLayout = (props) => {
  const { children } = props;
  return <div>{children}</div>;
};

export default DefaultLayout;
